<div class="container-fluid bg-light py-5">
  <div class="row align-items-center justify-content-around px-4">
    <div class="col-lg-6">
      <h2 class="fw-bold mb-3 headingBL">
        Power up Your Learning Environment:<br />
        <span>VIRSA All-in-One PCs</span>
      </h2>
      <h4 class="mb-3">
        Simplify Setup, Maximize Learning:<br />
        <strong>VIRSA All-in-One PCs for Streamlined Learning</strong>
      </h4>
      <p class="vtext">
        VIRSA All-in-One PCs offer a complete learning solution – powerful
        hardware, pre-loaded software, and a sleek design – perfect for any
        classroom or learning space.
      </p>
      <div class="d-flex align-items-center mt-4">
        <a class="btnGlobal--primary me-4" href="/assets/pdf/brochure-all-in-one-pc.pdf" target="_blank">
          Download Brochure
        </a>

        <div class="btnGlobal--primary" routerLink="/all-in-one-pc-computers-accessories">
          View More..
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <img src="assets/images/home/allinpac.jpg" class="img-fluid" alt="Virsa All-in-One PC for college" />
    </div>
  </div>
</div>

<div class="container-fluid py-5" style="
    background-image: url('assets/images/home/backdrop.png');
    background-size: cover;
    background-repeat: no-repeat;
  ">
  <h2 class="text-center fw-bold mb-4">Unlocking All-in-One PC Features</h2>
  <div class="row justify-content-center g-4 px-4">
    <div class="col-md-4" *ngFor="let feature of featureData">
      <app-feature-card [title]="feature.title" [iconSrc]="feature.iconSrc"
        [description]="feature.description"></app-feature-card>
    </div>
  </div>
</div>